/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".alert-danger[_ngcontent-%COMP%]{color:#721c24;background:#f8d7da;border-color:#f5c6cb;margin-bottom:5px}.container-error-message[_ngcontent-%COMP%]{padding:3px}"];
export { styles as styles };
